import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

interface PublicLayoutProps {
  children: React.ReactNode;
}

const PublicLayout = ({ children }: PublicLayoutProps) => {
  return (
    <div className="min-h-screen bg-white text-slate-950">
      <Navigation />
      <main className="pt-[72px]">{children}</main>
      <Footer />
    </div>
  );
};

export default PublicLayout;
